/**
 * @Author: Hanjianxin
 * @Desc: 所有的api接口
 * @Date: 2019-07-31
 */
import { get, post } from "./axios_service.js";
import * as axios from "axios";

//批次上传
export const bathBatchImport = axios.defaults.baseURL + "/batch/batchImport";
//单批次上传任务确认单
export const bathTaskConfirmUpload =
  axios.defaults.baseURL + "/batch/salaryConfirmationUpload";
//单批次下载任务确认单
export const bathTaskConfirmDownload =
  axios.defaults.baseURL + "/batch/confirmationDownload";
//多批次上传任务确认单
export const multiBathTaskConfirmUpload =
  axios.defaults.baseURL + "/batch/multiple/salaryConfirmationUpload";
//多批次下载任务确认单
export const multiBathTaskConfirmDownload =
  axios.defaults.baseURL + "/batch/multiple/confirmationDownload";
// 公用 - 上传图片 C：身份证、 D：营业执照、 K：开户许可证, PAYMENT_VOUCHER: 商户付款凭证
export const uploadImg = axios.defaults.baseURL + "/web/file/upload/by/code";
export const uploadOpenFile = axios.defaults.baseURL + "/file/uploadOpenFile"; // oem上传图片

// 首页变更函下载
export const downloadChangeNoticeLetter =
  axios.defaults.baseURL + "/cooperatorChannelChangeNoticeLetter/download";
// 交易中心---资金下发管理 -- 多批次数据准备 - 新增批次 01
export const multipleBatchesImport =
  axios.defaults.baseURL + "/batch/multiple/batchImport";
// 交易中心---资金下发管理 -- 多批次数据准备 - 下载 05
export const multipleBatchesFileDownload =
  axios.defaults.baseURL + "/batch/multiple/batchFileDownload";
//交易中心---资金下发管理 -- 多批次数据准备 - 批次数据准备详情导出 11
export const multipleBatchesExport =
  axios.defaults.baseURL + "/batch/list/exportBatchList";
//交易中心---资金下发管理 -- 上传服务费明细接口
export const uploadServiceDetail =
  axios.defaults.baseURL + "/upload/service/detail";
// 财务中心 - 预开发票申请
export const invoiceApplyExport =
  axios.defaults.baseURL + "/batch/invoice/export";
//用户信息上传
export const workerImportInfo = axios.defaults.baseURL + "/worker/importInfo";
//收款用户交易导出
export const exportStatisticsUrlStr =
  axios.defaults.baseURL + "/dataCenter/exportReceivableTransactionStatistics";
//收款用户交易统计详情导出
export const exportBusinessStatisticsDetailUrlStr =
  axios.defaults.baseURL +
  "/dataCenter/exportReceivableTransactionStatisticsDetails";
//Export - 代理商交易统计导出
export const exportAgentTransactionStatisticsUrlStr =
  axios.defaults.baseURL + "/dataCenter/exportAgentTransactionStatistics";
//代理商交易统计详情导出
export const exportAgentTransactionUrlStr =
  axios.defaults.baseURL + "/dataCenter/exportAgentTransactionStatisticsList";
//商户交易统计导出
export const exportBusinessStatisticsUrlStr =
  axios.defaults.baseURL + "/dataCenter/exportBusinessStatistics";
//商户交易统计详情导出
export const exportBusinessDetailsUrlStr =
  axios.defaults.baseURL + "/dataCenter/exportBusinessStatisticsDetail";
//批次明细导出
export const exportBatchListDealInfoQuerUrlStr =
  axios.defaults.baseURL + "/batchList/exportBatchListDealInfoQuery";
//批次数据准备详情导出
export const exportBatchInfoUrlStr =
  axios.defaults.baseURL + "/batchList/exportBatchInfo";
//批次数据准备提交-导出
export const exportBatchListUrlStr =
  axios.defaults.baseURL + "/batchList/exportBatchList";
//用户信息管理导出数据
export const exportExportWorkTempUrlStr =
  axios.defaults.baseURL + "/worker/export";
//余额管理导出数据01
export const exportCooperatorListExport =
  axios.defaults.baseURL + "/cooperator/balance/list/export";
//用户签约协议 查看导出
export const exportWorkersPro =
  axios.defaults.baseURL + "/worker/exportWorkersPro";
//个体户信息管理 查看导出
export const exportIndividualBusinessList =
  axios.defaults.baseURL +
  "/worker/deal/individual/exportIndividualBusinessList";
//个体户信息管理 签约协议批量导出
export const exportIndividualBusinessListContract =
  axios.defaults.baseURL +
  "/worker/deal/individual/exportIndividualBusiness/contract";
// 月环比数据导出
export const exportMonthOnMontData =
  axios.defaults.baseURL + "/web/agent/transaction/rate/export";
//商户充值记录导出
export const exportCooperatorRechargeExport =
  axios.defaults.baseURL + "/cooperator/recharge/record/list/export";
//电子回单批量导出
export const exportRecriptZip =
  axios.defaults.baseURL + "/cooperator/receipt/zip/download";
//单商户账户操作记录导出
export const exportCooperatorRecordExport =
  axios.defaults.baseURL + "/cooperator/balance/record/export";
//失败补发导出
export const exportDaochu =
  axios.defaults.baseURL + "/redistribute/cooperator/batchFailedExport";
//上传补发批次
export const exportReissue =
  axios.defaults.baseURL + "/redistribute/cooperator/reissueImport";
//补发批次详情导出
export const exportReissueUrlStr =
  axios.defaults.baseURL + "/redistribute/cooperator/exportReissueBatchList";
export const exportReissueUrld =
  axios.defaults.baseURL + "/redistribute/cooperator/exportReissueBatchList";
//补发统计详情导出
export const exportReissueDtail =
  axios.defaults.baseURL + "/dataCenter/cooperator/exportReissueBatchList";
//补发统计导出
export const exportqueryBatchReissue =
  axios.defaults.baseURL + "/dataCenter/exportqueryBatchReissue";
//补发统计详情导出
export const exportqueryBatchReissues =
  axios.defaults.baseURL + "/dataCenter/cooperator/exportReissueBatchList";
// 批量导入证件信息
export const multipleImportIdCard =
  axios.defaults.baseURL + "/batchImport/sign";
//文件下载公用接口
export const getFileDownLoad = axios.defaults.baseURL + "/common/file/download";
// 代开统计导出
export const exportOpenStat =
  axios.defaults.hvyosvUrl + "/deal/export/centerData/detail";
// 批次下载
export const batchFileDownload =
  axios.defaults.baseURL + "/batch/batchFileDownload";
export const FileDownload =
  axios.defaults.baseURL + "/redistribute/cooperator/batchReissueFileDownload";
// 完税证明导出
export const exportTaxProveZip =
  axios.defaults.baseURL + "/cooperator/tax/prove/zip/download";
// 完税证明详情导出
export const exportTaxProveDetailZip =
  axios.defaults.baseURL + "/cooperator/worker/tax/prove/zip/download";
//个体户订单列表导出
export const personalOrderExport =
  axios.defaults.baseURL + "/hire/order/export";
//CS001-1.0+ 收款信息比对
export const workerCheckHireReceiptInfo =
  axios.defaults.baseURL + "/worker/check/hire/worker/receipt/info";
//CS003-导出收款信息差异数据
export const exportDistributeCompanyWorkerStatistics =
  axios.defaults.baseURL +
  "/worker/export/distribute/company/worker/statistics";
// 导出管理费退还记录
export const exportFeeRefundRecordList =
  axios.defaults.baseURL + "/web/export/pricing/service/charge/return/record";
// 用工中心 - 上传结算单
export const batchSalaryImport =
  axios.defaults.baseURL + "/batch/salary/batchImport";
// LRZ-001-即配行业上传结算单
export const distributionIndustryImport =
  axios.defaults.baseURL + "/DistributionIndustry/Import/Batch";
// 导出查询工单列表
export const exportSalaryBatchList =
  axios.defaults.baseURL + "/batch/list/salary/exportBatchInfo";
// 导出用工结算明细
export const exportBatchInfoDesc =
  axios.defaults.baseURL + "/batch/list/salary/exportBatchListDealInfoQuery";
// 导出用功能结算单模板数据
export const exportPositionWorkerHire =
  axios.defaults.baseURL + "/exportPositionWorkerHireList";
// 导出任务列表
export const exportPositionList =
  axios.defaults.baseURL +
  "/cooperator/position/export/cooperator/position/list";
// 用工结算单 - 任务确认单
export const downloadPdf =
  axios.defaults.baseURL + "/batch/salary/confirmationDownload";
// 【提交结算单】- 任务确认单预览
export const findConfirmationDownload =
  axios.defaults.baseURL + "/batch/salary/findConfirmation/download";
// 用工中心- 查询任务确认单模版
export const findConfirmationTemplate =
  axios.defaults.baseURL + "/batch/salary/findConfirmation/template";
// 报名详情 - 导出人员模版2.0版本
export const designatedWorkerExportPosition =
  axios.defaults.baseURL + "/designatedWorkerExportPosition";
// 报名详情 - 导出人员模版1.0+版本
export const designatedWorkerExportPositionForOnePlus =
  axios.defaults.baseURL + "/designatedWorkerExportPositionForOnePlus";
// 用工中心 - 批量导入任务说明书
export const postImportMission =
  axios.defaults.baseURL + "/batch/import/missionStatement";
// 任务列表 - 批量邀请人员
export const postBatchInvitation =
  axios.defaults.baseURL + "/batchInvitationRecordUpload";
// 任务列表 - 批量邀请人员 导出上次错误信息
export const getBatchInvitation =
  axios.defaults.baseURL + "/batchInvitation/excel/import/download";
// 【安心签】- 查询任务确认单模版
export const findConfirmationTemp =
  axios.defaults.baseURL + "/batch/salary/findConfirmation/template";
// 上传用工结算单 - 导出错误原因及原始数据
export const exportErrorAndDataFile =
  axios.defaults.baseURL + "/batch/salary/import/download";
// 用工结算单 - 导出人任务确认单
export const exportTaskConfim =
  axios.defaults.baseURL + "/batch/salary/batch/download/confirmation";
// 余额管理 - 打款信息PDF文件下载
export const downloadPaymentPdf =
  axios.defaults.baseURL + "/cooperator/payment/info/file/download";
// 导出江西任务列表
export const exportJXPositionList =
  axios.defaults.baseURL +
  "/single/cooperator/position/export/cooperator/position/list";
// 余额管理 - 下载收款证明
export const downloadChannelInfoDownl =
  axios.defaults.baseURL + "/cooperator/payment/channel/info/file/download";
// 余额管理 - 下载收款证明
export const exportChannelInfoDownl =
  axios.defaults.baseURL + "/cooperator/channel/balance/record/export";
// 用工中心 合规材料上传
export const complianceMaterials =
  axios.defaults.baseURL +
  "/web/cooperator/position/compliance/center/save/compliance/materials";
// 用工中心 上传合作评估表
export const centerFileUpload = axios.defaults.baseURL + "/center/file/upload";
// 开票记录 - 导出开票记录列表
export const exportInvoiceList =
  axios.defaults.baseURL + "/export/invoice/record";
// 合规中心 ---下载合作评估表
export const uoloadCooperationForm =
  axios.defaults.baseURL + "/center/uoloadCooperationForm";
// 任务中心 - 任务详情导出
export const exportDetailList =
  axios.defaults.baseURL + "/cooperator/position/web/worker/detail/export";
// 用工结算单 - 失败批次数据导出
export const failBatchExportUrl =
  axios.defaults.baseURL + "/batch/list/salary/failBatchTemplate";
// 导出提现结算模版
export const exportWithdrawTemplate =
  axios.defaults.baseURL + "/exportWithdrawTemplate";
// 合同管理线上签署 - 导出合同
export const exportContractTemplate =
  axios.defaults.baseURL + "/whiteness/cooperator/export/contract/template";
// 历史结算数据列表导出
export const exportHistoryBatchListList =
  axios.defaults.baseURL + "/history/webBatchListListExport";
// 优惠券管理 - 使用明细 - 导出
export const exportCouponDetail =
  axios.defaults.baseURL + "/web/coupon/usage/detail/export";
// 代理商历史交易统计[列表导出]
export const exportAgentTransactionStatistics =
  axios.defaults.baseURL + "/history/exportAgentTransactionStatistics";
// [WEB]代理商历史交易统计详情[列表导出]
export const exportWebAgentTransactionStatisticsList =
  axios.defaults.baseURL + "/history/exportWebAgentTransactionStatisticsList";
// 用工结算单申诉 - 上传承诺书
export const uploadConfirmationLetter =
  axios.defaults.baseURL + "/cooperator/staff/uploadConfirmationLetter";
// 下载承诺书
export const exportConfirmationLetter =
  axios.defaults.baseURL + "/cooperator/staff/getLeaderSameNameTemplate";
// 上传文件
export const uploadFileByFolder =
  axios.defaults.baseURL + "/file/upload/file/by/folder";
// 新增测算批次1.0+上传
export const uploadImportPreCalculateBatch =
  axios.defaults.baseURL + "/batch/salary/importPreCalculateBatch";
// 导出测算流水列表导出
export const exportImportPreCalculateBatch =
  axios.defaults.baseURL + "/batch/salary/preCalculateBatchListListExport";
// 导出排班管理数据
export const exportPositionScheduleList =
  axios.defaults.baseURL + "/cooperator/webPositionScheduleListExport";
// 用工花名册导出
export const exportEmploymentRoster =
  axios.defaults.baseURL + "/cooperator/webPositionWorkerScheduleListExport";
// 考勤列表导出
export const exportPositionScheduleAttendanceListExport =
  axios.defaults.baseURL +
  "/cooperator/webPositionScheduleAttendanceListExport";
// 交付物列表导出
export const exportPositionScheduleDeliveryListExport =
  axios.defaults.baseURL + "/cooperator/webPositionScheduleDeliveryListExport";
// 用工确认记录详情列表导出:工时制
export const exportPositionScheduleConfirmListExport10 =
  axios.defaults.baseURL + "/cooperator/webPositionScheduleConfirmListExport10";
// 用工确认记录详情列表导出:项目制
export const exportPositionScheduleConfirmListExport20 =
  axios.defaults.baseURL + "/cooperator/webPositionScheduleConfirmListExport20";
// 用工确认记录详情文件上传批量编辑:工时制
export const webPositionScheduleConfirmFileUpload10 =
  axios.defaults.baseURL + "/cooperator/webPositionScheduleConfirmFileUpload10";
// 用工确认记录详情文件上传批量编辑:项目制
export const webPositionScheduleConfirmFileUpload20 =
  axios.defaults.baseURL + "/cooperator/webPositionScheduleConfirmFileUpload20";



// WEBPACK FOOTER //
// ./src/service/apis.js